var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMydashboardShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5605 3.32888L16.5 4.38862L19.626 7.50037H12.375C11.2813 7.50157 10.2328 7.93655 9.4595 8.70988C8.68617 9.4832 8.25119 10.5317 8.25 11.6254C8.25 13.9001 10.101 15.7504 12.375 15.7504H12.75V14.2504H12.375C10.9275 14.2504 9.75 13.0729 9.75 11.6254C9.75 10.1779 10.9275 9.00037 12.375 9.00037H19.629L16.506 12.1234L17.5665 13.1839L22.5 8.25037L17.5605 3.32812V3.32888ZM3.75 3.75038V20.2504H20.25V12.7504L18.75 14.2504V18.7504H5.25V5.25037H13.3905L14.8905 3.75038H3.75Z",
    fill: "rgb(0,100,216)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydashboardShareIcon);
export default __webpack_public_path__ + "static/media/mydashboard_share_icon.c8c466c566c6bc77f49af1b50037cfe3.svg";
export { ForwardRef as ReactComponent };